import * as React from "react";
import type { SVGProps } from "react";
const SvgOfficeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 36 36"
    {...props}
  >
    <path
      fill="#858585"
      fillRule="evenodd"
      d="M6.404 6.166A.56.56 0 0 1 6.8 6h12.32c.148 0 .29.06.396.166.105.107.164.251.164.402v7.377c0 .15-.059.295-.164.401a.56.56 0 0 1-.396.167h-4.48v1.702h8.4v-4.54c0-.15.059-.295.164-.401a.56.56 0 0 1 .396-.166h1.68V9.405c0-.15.059-.295.164-.401a.56.56 0 0 1 .396-.166h2.24c.149 0 .29.06.396.166.105.106.164.25.164.401v.568h1.68c.148 0 .29.06.396.166.105.106.164.25.164.401v5.675h.56c.148 0 .29.06.396.166.105.107.164.251.164.402v.313c0 .15-.059.295-.164.401a.56.56 0 0 1-.396.166h-.56v11.761c0 .15-.059.295-.164.402a.56.56 0 0 1-.396.166H20.8a.56.56 0 0 1-.396-.166.57.57 0 0 1-.164-.402v-7.788h-14v7.788a.57.57 0 0 1-.161.407.56.56 0 0 1-.615.125.56.56 0 0 1-.304-.312.6.6 0 0 1-.04-.22v-11.76h-.56a.56.56 0 0 1-.396-.167.57.57 0 0 1-.164-.401v-.313c0-.15.059-.295.164-.402a.56.56 0 0 1 .396-.166h6.72v-1.702H6.8a.56.56 0 0 1-.396-.167.57.57 0 0 1-.164-.4V6.567c0-.151.059-.295.164-.402m12.156.969H7.36v6.243h11.2zm8.96 2.838H26.4v6.242h1.12V9.973m2.24 1.135h-1.12v5.107h1.12zm-4.48 1.135h-1.12v3.972h1.12zm-11.76 2.27H12.4v1.702h1.12zm6.72 3.15h-14v2.838h14zm9.52 0h-8.4v4.54h8.4zm0 5.675h-8.4v5.519h8.4zM34 31H2v1h32z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOfficeIcon;
